export default {
  getArnActiveTab: state => state.arnActiveTab,
}
